import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import { linkResolver } from '../utils/linkResolver'
import Img from "gatsby-image"

export default () => (
  <StaticQuery
    query={graphql`
        {
          prismic {
              allPosts(sortBy: meta_firstPublicationDate_ASC) {
                edges {
                  node {
                    _meta{
                        type
                        uid
                      }
                    title
                    timespan
                    image
                    imageSharp {
                      childImageSharp {
                        fluid(quality: 100) {
                            ...GatsbyImageSharpFluid
                          }
                      }
                    }
                  }
                }
              }
            }
          }
        `}
    render={data => (
      <div className="grid-child with-content">
        <div className="content-intro">
          <h2>TIMELINE.</h2>
          <h4>These timeline posts were written mostly in hindsight and generated from my journal entries, a detailed timesheet, and any relevant screenshots/media I had saved that week.</h4>
          <p>← Scroll Left</p>
        </div>
        <div className="card-parent home">
          {data.prismic.allPosts.edges.map(({ node: post }, i) => (
            <Link to={linkResolver(post._meta)} key={i} className="no-decoration">
              <div className="card w-inline-block">
                <div className="card-label">
                  <h4 className="card-title">{post.title[0].text}</h4>
                  <div>{post.timespan[0].text}</div>
                </div>
                <div className="card-image">
                  <Img fluid={post.imageSharp.childImageSharp.fluid} className="image" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    )}
  />
)